import { Action, Event } from "render/hooks/useTracking";

const category = "ShareBookingView";

export const shareBookingEvent = {
  shareClick: (): Event => {
    return {
      category,
      action: Action.Click,
      label: "share_button",
    };
  },
  continueClick: (): Event => {
    return {
      category,
      action: Action.Click,
      label: "continue_button",
    };
  },
};
